import { render, staticRenderFns } from "./VehicleCreateView.vue?vue&type=template&id=8373c57a&scoped=true&"
import script from "./VehicleCreateView.vue?vue&type=script&lang=js&"
export * from "./VehicleCreateView.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCreateView.vue?vue&type=style&index=0&id=8373c57a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8373c57a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
